/* eslint-disable jsx-a11y/mouse-events-have-key-events */
/* eslint-disable no-restricted-syntax */
/* eslint-disable react/button-has-type */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable jsx-a11y/mouse-events-have-key-events */
/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable react/jsx-no-useless-fragment */
import Icon, {
  CaretDownOutlined,
  FrownTwoTone,
  SmileOutlined,
  SmileTwoTone,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import {
  Avatar,
  Button,
  Divider,
  Drawer,
  Form,
  message as antdMessage,
  Popover,
  Table,
  Tooltip,
  Typography,
} from "antd";
import { isEmpty } from "lodash";
import React, { Fragment, useContext, useMemo, useRef, useState } from "react";
import ReactMarkdown from "react-markdown";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { EAI_LOGO_GRAPHIC_ONLY } from "../../../config";
import { useDevice } from "../../../hooks/useDevice";
import TranslateIcon from "../../../../static/icons/TranslateIcon.svg";
import AiFeedbackButtons from "./AiFeedbackButtons";
import { shouldShowAiFeedback } from "../../../helpers/aiFeedbackHelper";
import { useOpportunityBadge } from "../../../hooks/useOpportunityBadge";
import { ReviewTrackingInline } from "../../reviews/ReviewTracking";
import { UserContext } from "../../../amplify/authenticator-provider";
import { CREATE_EMAIL, TRANSLATE_MESSAGE } from "../../../graphql/mutation";
import { GET_DETECTED_LANGUAGE, GET_SUPPORTED_LANGUAGES_BY_LOCATION } from "../../../graphql/query";
import useCrm from "../../../hooks/useCrm";
import useCrmIntegration from "../../../hooks/useCrmIntegration";
import useLang from "../../../hooks/useLang";
import { ReplyIcon } from "../../../icons/js/EmailIcons";
import { ReminderIcon16 } from "../../../icons/js/RemainderIcon";
import { SVGIcon } from "../../../library/basicComponents";
import {
  AccessPermissionAction,
  MESSAGE_CONTAINER_CLASSNAME,
  MESSAGE_TYPES,
  MESSAGE_CONTENT_TYPES,
  MESSAGE_FEEDBACK_TYPE,
} from "../../../library/constants";
import { checkAccessPermission, isAllLocationSelected } from "../../../library/helpers";
import { convertUtcToLocal, formatBytes } from "../../../library/utils";
import { getRootOppTypeIdForLeadOpportunityId } from "../../../library/oppTypeScoping";
import { getRootConfig } from "../../../library/oppTypeRootConfig";
import { getMobileView } from "../../../redux/slices/isMobile";
import {
  setTranlatedContent,
  setMessageFeedback,
  setSelectedLeadRedux,
} from "../../../redux/slices/leadSlice";
import AntdIconV4 from "../../../utils/antdIcon";
import { convertToInitials } from "../../layoutComponent/layoutHelpers";
import { ReplyEmail } from "./Emails";
import {
  getUniqueVehicleOfInterest,
  getVehicleName,
  parseEmailReply,
  renderLinks,
  isTypeOfCampaignEmail,
  linkifyPlainUrls,
} from "./engagementHelpers";
import { ultraSmartTruncate, truncateAddress } from "../../../utils/htmlTruncation";
import { formatEmailBodyHtml } from "../../../utils/htmlHelpers";
import BellIcon from "./icons/BellIcon";
import Calendar12Icon from "./icons/calendar";
import CampaignEmailIcon from "./icons/CampaignEmailIcon";
import CampaignMessageIcon from "./icons/CampaignMessageIcon";
import EmailIcon from "./icons/EmailIcon";
import EnvalopeIcon from "./icons/EnvalopeIcon";
import HandShake from "./icons/handShake";
import MediaSharing from "./mediaSharing/mediaSharing";
import MultipleMediaView from "./mediaSharing/multipleMediaView";
import MediaTrackingDrawer from "./MediaTrackingDrawer";
import MessageFeedback from "./MessageFeedback";
import MessageFeedbackList from "./MessageFeedbackList";
import MessageMetaInfo from "./MessageMetaInfo";
import "./messages.css";
import { renderEmailStatus, EMAIL_STATUS_ENUMS } from "../../../constant/EmailConstant";
import CallMessage from "./AudioCallComponents/CallMessages";
import UserHoverCard from "./PinMessages/UserHoverCard";
import PinnedMessageTag from "./PinMessages/PinnedMessageTag";
import { getActiveSupportedLanguages } from "../../../utils/languages";
import ClockStopNote from "./AudioCallComponents/ClockStopNote";
import ConsentUpdateMessage from "./ConsentUpdateMessage";
import BouncedEmailResend from "./emailComponents/BouncedEmailResend";

export const AppointmentBox = styled.div`
  text-align: center;
  margin: 2rem auto;
  width: 90%;
  max-width: 600px;
  @media (max-width: 488px) {
    width: 95%;
  }
  & .ant-alert-info,
  .ant-alert-success {
    border: 0;
  }
  & .anticon-calendar,
  .anticon-android {
    font-size: 20px;
    color: #007dae;
  }
`;
export const LineDiv = styled.div`
  &::before {
    background: ${props => props.colorprop} !important;
  }
`;
function parsePhone(selectedLead, crmIntegration, user, c) {
  const toPhoneNumber =
    (c?.messageLog && c?.messageLog.length > 0 && c?.messageLog[0].toPhone) || "";
  return toPhoneNumber;
}

const Messages = props => {
  const {
    SetContentBy,
    c: message,
    userIdMap,
    selectedLead,
    handleRetry,
    messageIndex,
    canViewTranslation,
    isIncludeOriginalMessage,
    hasAnyForwardOption,
  } = props;
  const crmIntegration = useCrmIntegration();
  const dispatch = useDispatch();
  const { user } = useContext(UserContext);
  const [isOpenOttoMessage, setisOpenOttoMessage] = useState(false);
  const toPhone = parsePhone(selectedLead, crmIntegration, user, message);
  const msgType = (message?.messageType || "").toLowerCase();
  const msgContentType = (message?.contentType || "").toLowerCase();
  const [showMore, setShowMore] = useState(false);
  const [showMoreForReview, setShowMoreForReview] = useState(false);
  const [showMoreForCustomeAlert, setShowMoreForCustomeAlert] = useState(false);
  const [lang] = useLang();
  const isMobileView = useSelector(state => getMobileView(state));
  const { translatedContent } = useSelector(state => state.lead);
  const [translateMessage, { loading: translateMessageLoader }] = useMutation(TRANSLATE_MESSAGE);
  const [detectedLanguage, setDetectedLanguage] = useState(null);
  const [languages, setLanguages] = useState([]);
  const [visible, setVisible] = useState(false);
  const [showTranslatedText, setShowTranslatedText] = useState(true);
  const [visibleTranslateIcon, setVisibleTranslateIcon] = useState(false);

  const canEmailView = checkAccessPermission(AccessPermissionAction.EMAIL_MANAGEMENT_VIEW);

  const { refetch: refetchSupportedLanguages } = useQuery(GET_SUPPORTED_LANGUAGES_BY_LOCATION, {
    onCompleted: res => {
      const languages = getActiveSupportedLanguages(res?.getSupportedLanguages);
      setLanguages(languages);
    },
    variables: {
      locationId: isAllLocationSelected() ? null : sessionStorage.getItem("currentLocationId"),
    },
  });

  const [getDetectedLanguage, { loading: getDetectedLanguageLoader }] = useLazyQuery(
    GET_DETECTED_LANGUAGE,
    {
      variables: {
        content: message?.translatedContent || message?.content,
      },
      onCompleted: res => {
        const possibleDetectedLanguage = languages?.find(item =>
          item?.languageCode.includes(res?.getLanguageCode?.code)
        );
        setDetectedLanguage(possibleDetectedLanguage?.languageCode);
      },
    }
  );

  function getTranslatedTextById() {
    const foundObj = translatedContent.find(obj => obj.id === message?.id);
    return foundObj ? foundObj.translatedContent : null;
  }

  const returnTranslatedContent = () => {
    if (getTranslatedTextById()) {
      return (
        <>
          {(isIncludeOriginalMessage || getTranslatedTextById()) && (
            <Divider style={{ margin: "16px 0", background: "#94A3B8" }} />
          )}
          Translated Text:
          <br />
          {renderLinks(getTranslatedTextById(), "black")}
        </>
      );
    }
  };

  const returnTranslatedContentGlobally = content => {
    if (content) {
      return (
        <>
          {isIncludeOriginalMessage && (
            <Divider style={{ margin: "16px 0", background: "#94A3B8" }} />
          )}
          Translated Text:
          <br />
          {renderLinks(content, "black")}
        </>
      );
    }
  };

  const doTranslation = () => {
    translateMessage({
      variables: {
        content: message?.content,
        messageId: message?.id,
      },
      onCompleted: res => {
        if (res?.translateMessage?.statusCode === 200) {
          const temp = {
            id: message?.id,
            translatedContent: res?.translateMessage?.translatedContent,
          };
          !translatedContent.some(obj => +obj.id === +temp.id) &&
            dispatch(setTranlatedContent(temp));
          // message.info(res?.translateMessage?.message);
        } else {
          message.info(res?.translateMessage?.message);
        }
      },
    });
  };

  const RenderTranslation = () => {
    return (
      msgType !== "mms" && (
        <Tooltip title="Translate message">
          <span className="items-center" style={{ zIndex: 999 }}>
            <SVGIcon component={TranslateIcon} alt="Translate" onClick={() => doTranslation()} />
          </span>
        </Tooltip>
      )
    );
  };

  const RenderPhone = props => {
    const {
      direction,
      messagephone,
      messageLabel = "Message",
      messageReceiveLabel = "received from",
      messageSentLabel = "sent to",
      tooltipClassName = "",
    } = props;
    return (
      <div
        className={`${
          tooltipClassName || direction === "FROM_LEAD" ? "text-left" : "text-right"
        } clear-both`}
      >
        <span className={`text-xs font-[400] text-white `}>
          {`${messageLabel} ${
            direction === "FROM_LEAD" ? messageReceiveLabel : messageSentLabel
          }: ${messagephone}`}
        </span>
      </div>
    );
  };

  const RenderRetry = ({ allowRetry = true, className }) => {
    const errorMessage = `${message.errorCode || ""} ${message.errorMessage || ""}`;
    return (
      <Typography
        className={`!flex !items-center !justify-end !gap-2 ${className}`}
        variant="small"
        weight="medium"
      >
        <Tooltip placement="top" title={isEmpty(errorMessage.trim()) ? null : errorMessage}>
          <span>
            <AntdIconV4 type="ExclamationCircleFilled" className="text-red-500 text-xs" />
          </span>
        </Tooltip>
        <span className="text-[#FF4D4F] font-normal text-xs">{lang.msgFailedSend}. </span>
        {allowRetry && (
          <div
            className="text-[#1783FF] text-xs font-semibold cursor-pointer"
            onClick={e => handleRetry(e, message)}
          >
            {lang.retry}
          </div>
        )}
        {/* <p className="text-[11px] mb-[2px] text-right mr-[15px]">
      {userIdMap
        ? c?.systemUserId
          ? userIdMap && userIdMap[c?.systemUserId]
          : userIdMap && userIdMap[c?.userId]
        : c.user.fullName}{" "}
      {lang.postedAt}{" "}
      {convertUtcToLocal(c?.dateSent, "ddd, MMM Do YYYY, h:mm A")}
      <br />
      {c?.errorMessage}
    </p> */}
      </Typography>
    );
  };
  let index = 0;
  const components = {
    img: ({ src, alt }) => (
      <a
        href={document.getElementById(`cardetail-${index}`)?.getAttribute("href")}
        target="_blank"
        rel="noreferrer"
        id=""
      >
        <img width={133} height={103} src={src} alt={alt} style={{ borderRadius: "5px" }} />
      </a>
    ),
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    a: ({ href, children }) => {
      index += 1;
      return (
        <a
          href={href}
          target="_blank"
          rel="noreferrer"
          id={`cardetail-${index}`}
          className="text-black underline hover:!text-twLinkColor"
        >
          {children}
        </a>
      );
    },
    ul: ({ children }) => (
      <ul
        style={{
          listStyle: "none",
          padding: "0px",
          margin: "0px",
        }}
      >
        {children}
      </ul>
    ),
  };

  const getMessageCategory = () => {
    // use icons from the JSX elements created from figma icons
    let msgCat = {
      title: "Notification",
      // icon: <BellIcon color="#A855F7" />,
      backgroundColor: "#DBEAFE",
    };
    console.log("msgContentType", msgContentType, msgType);
    if (msgType === "email") {
      // welcome Message
      msgCat = {
        title: `${message?.campaign?.name || "Campaign Email"}`,
        icon: <EmailIcon />,
        backgroundColor: "#F3E8FF",
      };
    } else if (msgContentType === MESSAGE_CONTENT_TYPES.WELCOME_MESSAGE.toLowerCase()) {
      // welcome Message
      msgCat = {
        title: "Welcome Message",
        icon: <HandShake />,
        backgroundColor: "#F3E8FF",
      };
    } else if (msgContentType === MESSAGE_CONTENT_TYPES.NEW_MESSAGE_RECEIVED.toLowerCase()) {
      msgCat = {
        title: "New Message Received",
        icon: <EnvalopeIcon />,
        backgroundColor: "#F3E8FF",
      };
    }
    // New Message reminder
    else if (msgContentType === MESSAGE_CONTENT_TYPES.NEW_MESSAGE_REMINDER.toLowerCase()) {
      msgCat = {
        title: "New Message Reminder",
        icon: <EnvalopeIcon />,
        backgroundColor: "#F3E8FF",
      };
    } else if (
      [
        MESSAGE_CONTENT_TYPES.APPOINTMENT_SCHEDULED_NOTIFICATION_TO_USER.toLowerCase(),
        MESSAGE_CONTENT_TYPES.APPOINTMENT_RESCHEDULED_NOTIFICATION_TO_USER.toLowerCase(),
      ].includes(msgContentType) &&
      msgType.toLowerCase() === "otto"
    ) {
      msgCat = {
        title: `Appointment ${
          msgContentType ===
          MESSAGE_CONTENT_TYPES.APPOINTMENT_SCHEDULED_NOTIFICATION_TO_USER.toLowerCase()
            ? "Scheduled"
            : "Rescheduled"
        }`,
        icon: <Calendar12Icon />,
        backgroundColor: "#DBEAFE",
        className: "normal-otto",
      };
    } else if (
      [MESSAGE_CONTENT_TYPES.SENT_APPOINTMENT_RESCHEDULE_LINK_TO_LEAD.toLowerCase()].includes(
        msgContentType
      )
    ) {
      msgCat = {
        title: "Appointment Reschedule Link",
        icon: <Calendar12Icon />,
        backgroundColor: "#DBEAFE",
        className: "normal-otto",
      };
    } else if (
      [
        MESSAGE_CONTENT_TYPES.APPOINTMENT_RESCHEDULED_ALERT_TO_USER.toLowerCase(),
        MESSAGE_CONTENT_TYPES.REQUEST_TO_RESCHEDULE_APPOINTMENT.toLowerCase(),
      ].includes(msgContentType)
    ) {
      msgCat = {
        title: "Appointment Reschedule Requested",
        icon: <Calendar12Icon />,
        backgroundColor: "#DBEAFE",
        className: "normal-otto",
      };
    } else if (
      [
        MESSAGE_CONTENT_TYPES.APPOINTMENT_RESCHEDULE_TO_LEAD.toLowerCase(),
        MESSAGE_CONTENT_TYPES.APPOINTMENT_RESCHEDULE_TO_USER.toLowerCase(),
      ].includes(msgContentType)
    ) {
      msgCat = {
        title: "Appointment Rescheduled",
        icon: <Calendar12Icon />,
        backgroundColor: "#DBEAFE",
        className: "normal-otto",
      };
    } else if (
      [
        MESSAGE_CONTENT_TYPES.NEW_APPOINTMENT_CREATED.toLowerCase(),
        MESSAGE_CONTENT_TYPES.NEW_APPOINTMENT_CREATED_TO_LEAD.toLowerCase(),
        MESSAGE_CONTENT_TYPES.APPOINTMENT_SCHEDULED.toLowerCase(),
        MESSAGE_CONTENT_TYPES.APPOINTMENT_SCHEDULED_TO_LEAD.toLowerCase(),
        MESSAGE_CONTENT_TYPES.APPOINTMENT_SCHEDULED_NOTIFICATION_TO_USER.toLowerCase(),
        MESSAGE_CONTENT_TYPES.APPOINTMENT_SCHEDULED_TO_USER.toLowerCase(),
      ].includes(msgContentType)
    ) {
      msgCat = {
        title: "Appointment Booked",
        icon: <Calendar12Icon />,
        backgroundColor: "#DBEAFE",
        className: "normal-otto",
      };
    } else if (
      [
        MESSAGE_CONTENT_TYPES.APPOINTMENT_REMINDER_MESSAGE_TO_LEAD.toLowerCase(),
        MESSAGE_CONTENT_TYPES.APPOINTMENT_PAST_REMINDER.toLowerCase(),
        MESSAGE_CONTENT_TYPES.APPOINTMENT_PAST_REMINDER_TO_LEAD.toLowerCase(),
        MESSAGE_CONTENT_TYPES.NOT_ACTIVE_APPOINTMENT_TO_LEAD.toLowerCase(),
      ].includes(msgContentType)
    ) {
      msgCat = {
        title: "Appointment Reminder",
        icon: (
          <div className="flex flex-row items-center gap-1">
            <BellIcon />
            <Calendar12Icon />
          </div>
        ),
        backgroundColor: "#DBEAFE",
        className: "normal-otto",
      };
    } else if (
      [
        MESSAGE_CONTENT_TYPES.APPOINTMENT_CANCELLED.toLowerCase(),
        MESSAGE_CONTENT_TYPES.APPOINTMENT_CANCELLED_TO_LEAD.toLowerCase(),
        MESSAGE_CONTENT_TYPES.APPOINTMENT_CANCELLED_TO_USER.toLowerCase(),
      ].includes(msgContentType)
    ) {
      // Appointment Cancelled
      msgCat = {
        title: "Appointment Cancelled",
        backgroundColor: "#DBEAFE",
        className: "cancel-otto",
        icon: (
          <div className="flex flex-row items-center gap-1">
            {/* <CancelledIcon /> */}
            <Calendar12Icon />
          </div>
        ),
      };
    } else if (
      [
        MESSAGE_CONTENT_TYPES.APPOINTMENT_CONFIRMED.toLowerCase(),
        MESSAGE_CONTENT_TYPES.APPOINTMENT_CONFIRMED_TO_LEAD.toLowerCase(),
        MESSAGE_CONTENT_TYPES.APPOINTMENT_CONFIRMED_NOTIFICATION_TO_USER.toLowerCase(),
        MESSAGE_CONTENT_TYPES.APPOINTMENT_CONFIRMED_NOTIFICATION_TO_LEAD.toLowerCase(),
      ].includes(msgContentType)
    ) {
      msgCat = {
        title: "Appointment Confirmed",
        backgroundColor: "#DBEAFE",
        className: "normal-otto",
        icon: (
          <div className="flex flex-row items-center gap-1">
            {/* <CheckBoxIcon /> */}
            <Calendar12Icon />
          </div>
        ),
      };
    } else if (
      [MESSAGE_CONTENT_TYPES.APPOINTMENT_NO_SHOWED_STATUS_TO_LEAD.toLowerCase()].includes(
        msgContentType
      )
    ) {
      msgCat = {
        title: "Attempted Appointment Reschedule",
        backgroundColor: "#DBEAFE",
        className: "normal-otto",
        icon: (
          <div className="flex flex-row items-center gap-1">
            <Calendar12Icon />
          </div>
        ),
      };
    } else if (
      [MESSAGE_CONTENT_TYPES.APPOINTMENT_SHOWED_STATUS_TO_LEAD.toLowerCase()].includes(
        msgContentType
      )
    ) {
      msgCat = {
        title: "Successful Appointment Completion",
        backgroundColor: "#DBEAFE",
        className: "normal-otto",
        icon: (
          <div className="flex flex-row items-center gap-1">
            {/* <CheckBoxIcon /> */}
            <Calendar12Icon />
          </div>
        ),
      };
    } else if (
      [MESSAGE_CONTENT_TYPES.APPOINTMENT_STATUS_UPDATE_BY_OTTO.toLowerCase()].includes(
        msgContentType
      )
    ) {
      msgCat = {
        title: "Appointment Status Updated",
        backgroundColor: "#DBEAFE",
        className: "normal-otto",
        icon: (
          <div className="flex flex-row items-center gap-1">
            {/* <CheckBoxIcon /> */}
            <Calendar12Icon />
          </div>
        ),
      };
    } else if (
      [MESSAGE_CONTENT_TYPES.APPOINTMENT_STATUS_UPDATE.toLowerCase()].includes(msgContentType)
    ) {
      msgCat = {
        title: "Appointment Status Update",
        backgroundColor: "#DBEAFE",
        className: "normal-otto",
        icon: (
          <div className="flex flex-row items-center gap-1">
            {/* <CheckBoxIcon /> */}
            <Calendar12Icon />
          </div>
        ),
      };
    } else if ([MESSAGE_CONTENT_TYPES.REVIEW_REQUEST_SENT.toLowerCase()].includes(msgContentType)) {
      msgCat = {
        title: <span className="text-nowrap">Review Request Sent</span>,
        icon: <SmileOutlined />,
        backgroundColor: "#FEF3C7",
        className: "normal-otto",
      };
    } else if (
      [
        MESSAGE_CONTENT_TYPES.CAMPAIGN.toLowerCase(),
        MESSAGE_CONTENT_TYPES.CAMPAIGN_MESSAGE_TO_LEAD.toLowerCase(),
        MESSAGE_CONTENT_TYPES.CAMPAIGN_REVIEW_REQUEST_SENT_TO_LEAD.toLowerCase(),
      ].includes(msgContentType)
    ) {
      msgCat = {
        title: message?.campaign?.name || "Campaign",
        icon:
          message?.campaign?.method === "Email" ? <CampaignEmailIcon /> : <CampaignMessageIcon />,
        backgroundColor: "#DBEAFE",
        className: "normal-otto",
        category: "Campaign",
      };
    } else if (
      [MESSAGE_CONTENT_TYPES.NEW_MESSAGE_MERGED_LEAD.toLowerCase()].includes(msgContentType)
    ) {
      msgCat = {
        title: "Merged Records",
        icon: (
          <svg xmlns="http://www.w3.org/2000/svg" width={22} height={22} fill="none">
            <path
              fill="#22C55E"
              d="M15.37 6.627a7.5 7.5 0 1 0-8.743 8.743 7.5 7.5 0 1 0 8.743-8.743ZM2 7.999a6 6 0 0 1 11.812-1.5 7.507 7.507 0 0 0-7.308 7.312 6.01 6.01 0 0 1-4.505-5.813Zm12 12a6.01 6.01 0 0 1-5.813-4.5 7.508 7.508 0 0 0 7.313-7.313 6 6 0 0 1-1.5 11.813Z"
            />
          </svg>
        ),
        backgroundColor: "#DCFCE7",
      };
    } else if (
      [MESSAGE_CONTENT_TYPES.NEW_OPPORTUNITY_MESSAGE_MERGED_LEAD.toLowerCase()].includes(
        msgContentType
      )
    ) {
      msgCat = {
        title: "Opportunity Merged",
        icon: (
          <svg xmlns="http://www.w3.org/2000/svg" width={22} height={22} fill="none">
            <path
              fill="#22C55E"
              d="M15.37 6.627a7.5 7.5 0 1 0-8.743 8.743 7.5 7.5 0 1 0 8.743-8.743ZM2 7.999a6 6 0 0 1 11.812-1.5 7.507 7.507 0 0 0-7.308 7.312 6.01 6.01 0 0 1-4.505-5.813Zm12 12a6.01 6.01 0 0 1-5.813-4.5 7.508 7.508 0 0 0 7.313-7.313 6 6 0 0 1-1.5 11.813Z"
            />
          </svg>
        ),
        // backgroundColor: "#DCFCE7",
      };
    } else if (
      [
        MESSAGE_CONTENT_TYPES.NUDGE_NEW_LEAD_MESSAGE.toLowerCase(),
        MESSAGE_CONTENT_TYPES.NUDGE_RECEIVED_BY_SMAI_OTTO_FROM_USER.toLowerCase(),
      ].includes(msgContentType)
    ) {
      msgCat = {
        title: "New Message",
        icon: <BellIcon />,
        backgroundColor: "#DBEAFE",
        className: "normal-otto",
      };
    } else if ([MESSAGE_CONTENT_TYPES.AI_RESPONSE_TO_LEAD.toLowerCase()].includes(msgContentType)) {
      msgCat = {
        title: "Otto Message",
        icon: <BellIcon />,
        backgroundColor: "#DBEAFE",
        className: "normal-otto",
      };
    } else if (
      [MESSAGE_CONTENT_TYPES.SCHEDULED_MESSAGE_SENT.toLowerCase()].includes(msgContentType)
    ) {
      msgCat = {
        title: "Scheduled Message Sent",
        backgroundColor: "#CCFBF1",
        icon: <ReminderIcon16 />,
        className: "normal-otto",
      };
    } else if (
      [
        MESSAGE_CONTENT_TYPES.SCHEDULED_MESSAGE.toLowerCase(),
        MESSAGE_CONTENT_TYPES.SCHEDULED_MESSAGE_TO_LEAD.toLowerCase(),
      ].includes(msgContentType)
    ) {
      msgCat = {
        title: "Scheduled Message",
        backgroundColor: "#CCFBF1",
        icon: <ReminderIcon16 />,
        className: "normal-otto",
      };
    } else if (
      [MESSAGE_CONTENT_TYPES.SCHEDULED_MESSAGE_CANCELLED.toLowerCase()].includes(msgContentType)
    ) {
      msgCat = {
        title: "Scheduled Message Cancelled",
        backgroundColor: "#fbcccc",
        icon: <ReminderIcon16 />,
        className: "cancel-otto",
      };
    } else {
      msgCat = {
        title: "Notification",
        icon: <BellIcon />,
        backgroundColor: "#DBEAFE",
        className: "normal-otto",
      };
    }
    return msgCat;
  };

  const messageCategory = useMemo(getMessageCategory, [
    msgContentType,
    msgType,
    message?.campaign,
    message?.direction,
  ]);

  // Expand campaign message by default
  useMemo(() => {
    if (messageCategory && messageCategory.category === "Campaign") {
      setisOpenOttoMessage(true);
    }
  }, [messageCategory]);

  const userName = useMemo(() => {
    if (!isEmpty(userIdMap)) {
      const uName =
        message?.contentType === "AI Response To Lead"
          ? lang.autoResponderUserName
          : message?.systemUserId && message?.systemUserId != null
          ? userIdMap[+message?.systemUserId]
          : userIdMap[+message?.userId];
      return uName || message?.user?.fullName || user?.fullName;
    }
    return message?.user?.fullName || user?.fullName;
  }, [message, user, userIdMap]);

  // Reply-as (EAI-1530): resolve the ACTUAL sender's name from userIdMap for the
  // "on behalf of" badge/tooltip. userList cache often misses support/manager
  // accounts, but userIdMap (conversation participants) usually has them.
  const originalUserName = useMemo(() => {
    const oid = message?.originalUserId;
    if (!oid || isEmpty(userIdMap)) return "";
    return userIdMap[+oid] || "";
  }, [message, userIdMap]);

  const isCampaignEmailMessage =
    msgType === "email" &&
    message?.campaign &&
    msgContentType === MESSAGE_CONTENT_TYPES.CAMPAIGN_MESSAGE_TO_LEAD.toLowerCase();

  // Early returns for invalid states
  if (isEmpty(message)) return null;
  if (!msgType) return null;

  // Consent changes are audit events rather than conversation, so they get a
  // centered one-line system row instead of a bubble. Handled before the
  // bubble dispatch below, which would otherwise fall through to ToLeadSMS and
  // print the raw audit JSON.
  if (msgType === MESSAGE_TYPES.CONSENT_UPDATE.toLowerCase()) {
    return (
      <div
        id={`msg-${messageIndex}`}
        // dont change this classname as its being used for scrolling detection in useChatScroll hook
        className={MESSAGE_CONTAINER_CLASSNAME}
        data-message-id={message?.id}
      >
        <ConsentUpdateMessage
          message={message}
          userIdMap={userIdMap}
          leadName={selectedLead?.fullName}
        />
      </div>
    );
  }

  return isEmpty(message) ? null : msgType !== "mms" ? (
    <div
      id={`msg-${messageIndex}`}
      className={MESSAGE_CONTAINER_CLASSNAME} // dont change this classname as its being used for scrolling detection in useChatScroll hook
      data-message-id={message?.id}
      // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
      onMouseOver={() => setVisibleTranslateIcon(true)}
      onMouseLeave={() => {
        setVisibleTranslateIcon(false);
        setVisible(false);
      }}
    >
      <Fragment key={message?.id}>
        {["appointment", "otto", "review", "merge_lead", "merge_opportunity"].includes(msgType) ||
        isCampaignEmailMessage ? (
          <OttoMessage
            user={user}
            showMoreForCustomeAlert={showMoreForCustomeAlert}
            SetContentBy={SetContentBy}
            c={message}
            userIdMap={userIdMap}
            setShowMoreForCustomeAlert={setShowMoreForCustomeAlert}
            lang={lang}
            selectedLead={selectedLead}
            toPhone={toPhone}
            RenderRetry={RenderRetry}
            msgContentType={msgContentType}
            messageCategory={messageCategory}
            isOpenOttoMessage={isOpenOttoMessage}
            setisOpenOttoMessage={setisOpenOttoMessage}
            isReview={msgType === "review" || (message?.trackingDetails || []).length > 0}
            isLeadMerged={msgType === "merge_lead"}
            isOpportunityMerged={msgType === "merge_opportunity"}
            msgType={msgType}
            canEmailView={canEmailView}
            hasAnyForwardOption={hasAnyForwardOption}
            RenderPhone={RenderPhone}
          />
        ) : msgType !== "call" ? (
          <div>
            {message?.direction === "FROM_LEAD" ||
            message?.direction === "TO_USER" ||
            (message?.direction === "FROM_OTTO" && msgType === "review") ? (
              <div className="flex justify-start" key={message?.id}>
                {msgType.toLowerCase() === "email" ? (
                  <>
                    {canEmailView ? (
                      <EmailJSX
                        message={message}
                        isMobileView={isMobileView}
                        selectedLead={selectedLead}
                        canViewTranslation={canViewTranslation}
                        visibleTranslateIcon={visibleTranslateIcon}
                        RenderTranslation={RenderTranslation}
                        msgType={msgType}
                        msgContentType={msgContentType}
                        RenderPhone={RenderPhone}
                        lang={lang}
                        showMoreForReview={showMoreForReview}
                        isIncludeOriginalMessage={isIncludeOriginalMessage}
                        user={user}
                        getTranslatedTextById={getTranslatedTextById}
                        returnTranslatedContentGlobally={returnTranslatedContentGlobally}
                        returnTranslatedContent={returnTranslatedContent}
                        isOttoEmail={false}
                        hasAnyForwardOption={hasAnyForwardOption}
                      />
                    ) : null}
                  </>
                ) : (
                  <FromLeadSMS
                    isMobileView={isMobileView}
                    selectedLead={selectedLead}
                    canViewTranslation={canViewTranslation}
                    visibleTranslateIcon={visibleTranslateIcon}
                    RenderTranslation={RenderTranslation}
                    msgType={msgType}
                    msgContentType={msgContentType}
                    message={message}
                    RenderPhone={RenderPhone}
                    lang={lang}
                    showMoreForReview={showMoreForReview}
                    isIncludeOriginalMessage={isIncludeOriginalMessage}
                    user={user}
                    getTranslatedTextById={getTranslatedTextById}
                    returnTranslatedContentGlobally={returnTranslatedContentGlobally}
                    returnTranslatedContent={returnTranslatedContent}
                  />
                )}
              </div>
            ) : (
              <div className="flex justify-end" key={message?.id}>
                {msgType === "email" ? (
                  <>
                    {canEmailView ? (
                      <EmailJSX
                        message={message}
                        isMobileView={isMobileView}
                        selectedLead={selectedLead}
                        canViewTranslation={canViewTranslation}
                        visibleTranslateIcon={visibleTranslateIcon}
                        RenderTranslation={RenderTranslation}
                        msgType={msgType}
                        msgContentType={msgContentType}
                        RenderPhone={RenderPhone}
                        lang={lang}
                        showMoreForReview={showMoreForReview}
                        isIncludeOriginalMessage={isIncludeOriginalMessage}
                        user={user}
                        getTranslatedTextById={getTranslatedTextById}
                        returnTranslatedContentGlobally={returnTranslatedContentGlobally}
                        returnTranslatedContent={returnTranslatedContent}
                        userName={userName}
                        originalUserName={originalUserName}
                        hasAnyForwardOption={hasAnyForwardOption}
                      />
                    ) : null}
                  </>
                ) : (
                  <ToLeadSMS
                    isMobileView={isMobileView}
                    message={message}
                    user={user}
                    canViewTranslation={canViewTranslation}
                    visibleTranslateIcon={visibleTranslateIcon}
                    RenderTranslation={RenderTranslation}
                    RenderPhone={RenderPhone}
                    lang={lang}
                    userName={userName}
                    originalUserName={originalUserName}
                    components={components}
                    isIncludeOriginalMessage={isIncludeOriginalMessage}
                    getTranslatedTextById={getTranslatedTextById}
                    returnTranslatedContentGlobally={returnTranslatedContentGlobally}
                    returnTranslatedContent={returnTranslatedContent}
                    RenderRetry={RenderRetry}
                    selectedLead={selectedLead}
                    hasAnyForwardOption={hasAnyForwardOption}
                  />
                )}
              </div>
            )}
          </div>
        ) : msgType === "call" && msgContentType === "clocked stop note" ? (
          <ClockStopNote
            messageContentClass="max-w-[65%]"
            dateSent={message?.dateSent}
            content={message?.content}
            alignment="center"
          />
        ) : (
          <div
            className={`flex ${
              message?.direction === "FROM_LEAD" ? "justify-start" : "justify-end"
            }`}
          >
            <CallMessage
              RenderPhone={RenderPhone}
              message={message}
              user={user}
              userName={userName}
              selectedLead={selectedLead}
            />
          </div>
        )}
      </Fragment>
    </div>
  ) : message.direction === "TO_LEAD" ? (
    <div
      className={`flex justify-end w-full ${MESSAGE_CONTAINER_CLASSNAME}`}
      key={message?.id}
      id={`msg-${messageIndex}`}
      data-message-id={message?.id}
    >
      <ToLeadMessage
        isMobileView={isMobileView}
        c={message}
        user={user}
        canViewTranslation={canViewTranslation}
        visibleTranslateIcon={visibleTranslateIcon}
        RenderTranslation={RenderTranslation}
        RenderPhone={RenderPhone}
        userName={userName}
        originalUserName={originalUserName}
        isIncludeOriginalMessage={isIncludeOriginalMessage}
        getTranslatedTextById={getTranslatedTextById}
        returnTranslatedContentGlobally={returnTranslatedContentGlobally}
        returnTranslatedContent={returnTranslatedContent}
        RenderRetry={RenderRetry}
        hasAnyForwardOption={hasAnyForwardOption}
        selectedLead={selectedLead}
      />
    </div>
  ) : (
    <div
      className={`flex justify-start ${MESSAGE_CONTAINER_CLASSNAME}`}
      key={message?.id}
      id={`msg-${messageIndex}`}
      data-message-id={message?.id}
    >
      <FromLeadMessage
        isMobileView={isMobileView}
        selectedLead={selectedLead}
        canViewTranslation={canViewTranslation}
        visibleTranslateIcon={visibleTranslateIcon}
        RenderTranslation={RenderTranslation}
        RenderPhone={RenderPhone}
        c={message}
        isIncludeOriginalMessage={isIncludeOriginalMessage}
        user={user}
        getTranslatedTextById={getTranslatedTextById}
        returnTranslatedContentGlobally={returnTranslatedContentGlobally}
        returnTranslatedContent={returnTranslatedContent}
      />
    </div>
  );
};

export default Messages;

function ToLeadSMS({
  message,
  user,
  canViewTranslation,
  visibleTranslateIcon,
  RenderTranslation,
  RenderPhone,
  userName,
  originalUserName,
  components,
  isIncludeOriginalMessage,
  getTranslatedTextById,
  returnTranslatedContentGlobally,
  returnTranslatedContent,
  RenderRetry,
  selectedLead,
  hasAnyForwardOption,
}) {
  const isMessagePinned = !!message?.messageNotesCount;
  const [lang] = useLang();
  const dispatch = useDispatch();
  const messageFeedback = message?.messageFeedback || "";
  const [feedback, setFeedback] = useState(
    messageFeedback.includes("BAD") ? "bad" : messageFeedback.includes("GOOD") ? "good" : null
  );
  const [isFeedbackSent, setIsFeedbackSent] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isFeedbackListOpen, setIsFeedbackListOpen] = useState(false);
  const [form] = Form.useForm();
  const [showOttoReason, setShowOttoReason] = useState(false);
  const [isMediaTrackingOpen, setIsMediaTrackingOpen] = useState(false);

  // Whether this message has any feedback yet (decides list-vs-add on the feedback click).
  const hasExistingFeedback = !!(messageFeedback || message?.messageFeedbackNote);

  const handleFeedback = type => {
    if (hasExistingFeedback) {
      // Capture the clicked thumb so the edit/add form opens in that
      // Good/Negative mode, then surface the list of existing feedback.
      setFeedback(type);
      setIsFeedbackListOpen(true);
      return;
    }
    setFeedback(feedback === type ? null : type);
    setIsDrawerOpen(true);
  };

  const handleFeedbackSubmit = values => {
    // Preserve scroll position before state updates that may change DOM height
    const scrollContainer = document.getElementById("msgEndDiv");
    const prevScrollTop = scrollContainer?.scrollTop;

    setIsFeedbackSent(true);
    setIsDrawerOpen(false);
    form.resetFields();
    dispatch(
      setMessageFeedback({
        messageId: message?.id,
        feedback: values.feedback,
        feedbackNote: values.feedbackNote || "",
        feedbackOptionIds: values.feedbackOptionIds || [],
      })
    );

    // Restore scroll position after render
    if (scrollContainer && prevScrollTop !== undefined) {
      requestAnimationFrame(() => {
        scrollContainer.scrollTop = prevScrollTop;
      });
    }
  };

  const handleDrawerClose = closeFlag => {
    setIsDrawerOpen(false);
    if (closeFlag) {
      setFeedback(null);
    }
    setIsFeedbackSent(false);
    form.resetFields();
  };

  return (
    <div className="msg-bubble-wrapper">
      {message?.messageType === "WIDGET_CHAT" && (
        <div className="text-right">
          <AntdIconV4 type="MobileFilled" className="w-full text-center text-[#007dae]" />
        </div>
      )}

      <MessageMetaInfo
        direction="TO_LEAD"
        leadOpportunityId={message?.leadOpportunityId}
        leadOpportunities={selectedLead?.leadOpportunities}
        messageType={message?.messageType}
        contentType={message?.contentType}
        avatarUser={{
          fullName: message?.user?.fullName || user?.fullName,
          profilePic: message?.user?.profilePic,
        }}
        leadName={selectedLead?.fullName}
        showTranslationIcon={canViewTranslation && visibleTranslateIcon}
        RenderTranslation={RenderTranslation}
        timestamp={message?.dateSent}
        userName={userName}
        RenderPhone={RenderPhone}
        phoneNumber={
          (message?.messageLog &&
            message?.messageLog.length > 0 &&
            message?.messageLog[0]?.toPhone) ||
          ""
        }
        campaign={message?.campaign}
        isMessagePinned={isMessagePinned}
        messageNotesCount={message?.messageNotesCount}
        messageId={message?.id}
        messageContent={message?.content}
        messageUser={message?.user}
        originalUserId={message?.originalUserId}
        originalUserName={originalUserName}
        messageUserId={message?.userId}
        reasonForResponse={message?.reasonForResponse}
        hasAnyForwardOption={hasAnyForwardOption}
        isAutoResponder={userName === lang.autoResponderUserName}
        aiFeedbackProps={
          shouldShowAiFeedback({
            direction: message?.direction,
            contentType: message?.contentType,
            campaignType: message?.campaign?.campaignType?.type,
            dateSent: message?.dateSent,
          })
            ? {
                feedback,
                messageFeedback,
                isFeedbackSent,
                onFeedback: handleFeedback,
              }
            : null
        }
        showSentButton={!!message?.hasLinkTracking}
        onSentClick={() => setIsMediaTrackingOpen(true)}
        showRetry={
          message?.type === "error" ||
          message?.messageStatus === "FAILED" ||
          message?.messageStatus === "UNDELIVERED"
        }
        RetryComponent={<RenderRetry />}
        isSending={message?.type === "new" || message?.type === "queued"}
      >
        <div className="smaiChatSent">
          {message?.contentType === "AI Response To Lead" ? (
            <ReactMarkdown components={components}>
              {linkifyPlainUrls(message?.content)}
            </ReactMarkdown>
          ) : (
            renderLinks(
              isIncludeOriginalMessage || user?.isTranslationEnabled
                ? message?.content
                : message?.translatedContent || message?.content,
              "black"
            )
          )}

          {(isIncludeOriginalMessage || getTranslatedTextById()) &&
            message?.content !== message?.translatedContent &&
            message?.translatedContent && <br />}
          {isIncludeOriginalMessage &&
            !getTranslatedTextById() &&
            message?.content !== message?.translatedContent &&
            returnTranslatedContentGlobally(message?.translatedContent)}
          {returnTranslatedContent()}
        </div>
      </MessageMetaInfo>
      {isMediaTrackingOpen && (
        <MediaTrackingDrawer
          open={isMediaTrackingOpen}
          onClose={() => setIsMediaTrackingOpen(false)}
          messageId={message?.id}
          leadId={selectedLead?.id}
        />
      )}
      {isDrawerOpen && (
        <MessageFeedback
          isDrawerOpen={isDrawerOpen}
          onClose={handleDrawerClose}
          onFeedbackSubmit={handleFeedbackSubmit}
          form={form}
          messageId={message?.id}
          feedbackType={MESSAGE_FEEDBACK_TYPE.AUTORESPONDER}
          user={user}
          feedback={feedback || messageFeedback?.toLowerCase() || ""}
          feedbackNote={message?.messageFeedbackNote || ""}
          messageContent={message?.content || ""}
          reasonForResponse={message?.reasonForResponse || ""}
          campaign={message?.campaign}
          lead={selectedLead}
          feedbackOptionIds={
            (message?.messageFeedbackOptionSelection || []).map(item =>
              typeof item === "object" ? item?.messageFeedbackOption?.id || item?.id : item
            ) || []
          }
        />
      )}
      {isFeedbackListOpen && (
        <MessageFeedbackList
          isDrawerOpen={isFeedbackListOpen}
          currentUserId={user?.id}
          messageId={message?.id}
          onClose={() => setIsFeedbackListOpen(false)}
          onAddNew={() => {
            setIsFeedbackListOpen(false);
            setIsDrawerOpen(true);
          }}
          onEdit={() => {
            // Open the edit form in the mode of the thumb the user clicked
            // (captured in handleFeedback) so they can keep or flip the rating.
            setIsFeedbackListOpen(false);
            setIsDrawerOpen(true);
          }}
        />
      )}
    </div>
  );
}

function FromLeadSMS({
  selectedLead,
  canViewTranslation,
  visibleTranslateIcon,
  RenderTranslation,
  msgType,
  msgContentType,
  message,
  RenderPhone,
  lang,
  showMoreForReview,
  isIncludeOriginalMessage,
  user,
  getTranslatedTextById,
  returnTranslatedContentGlobally,
  returnTranslatedContent,
}) {
  return (
    <div className="msg-bubble-wrapper">
      {msgType === "review" &&
        (msgContentType?.includes("good") || msgContentType?.includes("bad")) && (
          <div className="flex items-center justify-end">
            {message?.contentType?.includes("Good") ? (
              <SmileTwoTone twoToneColor="#52c41a" className="text-[20px]" />
            ) : (
              <FrownTwoTone twoToneColor="red" className="text-[20px]" />
            )}
          </div>
        )}
      <MessageMetaInfo
        direction="FROM_LEAD"
        leadOpportunityId={message?.leadOpportunityId}
        leadOpportunities={selectedLead?.leadOpportunities}
        messageType={message?.messageType}
        contentType={message?.contentType}
        leadName={selectedLead?.fullName}
        showTranslationIcon={canViewTranslation && visibleTranslateIcon}
        RenderTranslation={RenderTranslation}
        timestamp={message?.dateReceived}
        RenderPhone={RenderPhone}
        phoneNumber={
          (message?.messageLog &&
            message?.messageLog.length > 0 &&
            message?.messageLog[0]?.fromPhone) ||
          ""
        }
        reasonForResponse={message?.reasonForResponse}
      >
        {msgType === "review" && (
          <span className="absolute top-[-12px] left-[15px] py-[2px] px-[10px] bg-yellow-200 text-amber-700 rounded-[6px] text-[12px]">
            {lang.review}
          </span>
        )}
        <div className="smaiChatRecieve">
          {renderLinks(
            isIncludeOriginalMessage || user?.isTranslationEnabled
              ? message?.content
              : message?.translatedContent || message?.content,
            "black"
          )}
          {(isIncludeOriginalMessage || getTranslatedTextById()) && <br />}
          {isIncludeOriginalMessage &&
            message?.translatedContent &&
            !getTranslatedTextById() &&
            message?.content !== message?.translatedContent &&
            returnTranslatedContentGlobally(message?.translatedContent)}
          {returnTranslatedContent()}
        </div>
      </MessageMetaInfo>
    </div>
  );
}

function FromLeadMessage({
  selectedLead,
  canViewTranslation,
  visibleTranslateIcon,
  RenderTranslation,
  RenderPhone,
  c,
  isIncludeOriginalMessage,
  user,
  getTranslatedTextById,
  returnTranslatedContentGlobally,
  returnTranslatedContent,
}) {
  const [isMediaTrackingOpen, setIsMediaTrackingOpen] = useState(false);

  return (
    <div className="msg-bubble-wrapper">
      <MessageMetaInfo
        direction="FROM_LEAD"
        leadOpportunityId={c?.leadOpportunityId}
        leadOpportunities={selectedLead?.leadOpportunities}
        messageType={c?.messageType}
        contentType={c?.contentType}
        leadName={selectedLead?.fullName}
        showTranslationIcon={canViewTranslation && visibleTranslateIcon}
        RenderTranslation={RenderTranslation}
        timestamp={c?.dateReceived}
        RenderPhone={RenderPhone}
        phoneNumber={
          (c?.messageLog && c?.messageLog.length > 0 && c?.messageLog[0]?.fromPhone) || ""
        }
        showSentButton={!!c?.hasLinkTracking}
        onSentClick={() => setIsMediaTrackingOpen(true)}
      >
        <div className="smaiChatRecieve">
          <div className="w-full">
            {c?.mmsObjects?.length <= 1 ? (
              <MediaSharing
                alt="msgText"
                direction={c.direction}
                selectedMedia={{
                  mediaUrl: c?.mmsObjects[0]?.mediaUrl,
                  mediaType: c?.mmsObjects[0]?.mediaType,
                  size: c?.mmsObjects[0]?.size,
                  thumbnailUrl: c?.mmsObjects[0]?.thumbnail,
                }}
                width="100%"
                height="auto"
              />
            ) : (
              <MultipleMediaView
                messageDetails={c}
                media={c.mmsObjects}
                selectedMedia={c.mmsObjects && c.mmsObjects[0]}
                alt="msgText"
                direction={c.direction}
                width="100%"
                height="auto"
              />
            )}
          </div>
          {c.content && (
            <div
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "space-between",
                padding: "10px 0 0 0",
              }}
            >
              <span>
                {renderLinks(
                  isIncludeOriginalMessage || user?.isTranslationEnabled
                    ? c?.content
                    : c?.translatedContent || c?.content,
                  "black"
                ) || ""}
              </span>
              {(isIncludeOriginalMessage || getTranslatedTextById()) && <br />}
              {isIncludeOriginalMessage &&
                c?.translatedContent &&
                !getTranslatedTextById() &&
                c?.content !== c?.translatedContent &&
                returnTranslatedContentGlobally(c?.translatedContent)}
              {returnTranslatedContent()}
            </div>
          )}
        </div>
      </MessageMetaInfo>
      {isMediaTrackingOpen && (
        <MediaTrackingDrawer
          open={isMediaTrackingOpen}
          onClose={() => setIsMediaTrackingOpen(false)}
          messageId={c?.id}
          leadId={selectedLead?.id}
        />
      )}
    </div>
  );
}

function ToLeadMessage({
  c,
  user,
  canViewTranslation,
  visibleTranslateIcon,
  RenderTranslation,
  RenderPhone,
  userName,
  originalUserName,
  isIncludeOriginalMessage,
  getTranslatedTextById,
  returnTranslatedContentGlobally,
  returnTranslatedContent,
  RenderRetry,
  hasAnyForwardOption,
  selectedLead,
}) {
  const isMessagePinned = !!c?.messageNotesCount;
  const [lang] = useLang();
  const [isMediaTrackingOpen, setIsMediaTrackingOpen] = useState(false);

  return (
    <div className="msg-bubble-wrapper">
      <MessageMetaInfo
        direction="TO_LEAD"
        leadOpportunityId={c?.leadOpportunityId}
        leadOpportunities={selectedLead?.leadOpportunities}
        messageType={c?.messageType}
        contentType={c?.contentType}
        avatarUser={{
          fullName: c?.user?.fullName || user?.fullName,
          profilePic: c?.user?.profilePic,
        }}
        leadName=""
        showTranslationIcon={canViewTranslation && visibleTranslateIcon}
        RenderTranslation={RenderTranslation}
        timestamp={c?.dateSent}
        userName={userName}
        RenderPhone={RenderPhone}
        phoneNumber={(c?.messageLog && c?.messageLog.length > 0 && c?.messageLog[0]?.toPhone) || ""}
        isMessagePinned={isMessagePinned}
        messageNotesCount={c?.messageNotesCount}
        messageId={c?.id}
        messageContent={c?.content}
        messageUser={c?.user}
        originalUserId={c?.originalUserId}
        originalUserName={originalUserName}
        messageUserId={c?.userId}
        hasAnyForwardOption={hasAnyForwardOption}
        isAutoResponder={userName === lang.autoResponderUserName}
        showSentButton={!!c?.hasLinkTracking}
        onSentClick={() => setIsMediaTrackingOpen(true)}
        showRetry={
          c?.type === "error" || c?.messageStatus === "FAILED" || c?.messageStatus === "UNDELIVERED"
        }
        RetryComponent={<RenderRetry />}
        isSending={c?.type === "new" || c?.type === "queued"}
      >
        <div className="smaiChatSent ml-auto">
          <div className="w-full">
            {c?.mmsObjects?.length <= 1 ? (
              <MediaSharing
                alt="msgText"
                direction={c.direction}
                selectedMedia={{
                  mediaUrl: c?.mmsObjects[0]?.mediaUrl,
                  mediaType: c?.mmsObjects[0]?.mediaType,
                  size: c?.mmsObjects[0]?.size,
                  thumbnailUrl: c?.mmsObjects[0]?.thumbnail,
                }}
                width="100%"
                height="auto"
              />
            ) : (
              <MultipleMediaView
                messageDetails={c}
                media={c.mmsObjects}
                alt="msgText"
                direction={c.direction}
                width="100%"
                height="auto"
              />
            )}
          </div>
          {c.content && (
            <div
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "space-between",
                padding: "10px 0 0 0",
              }}
            >
              <span className="break-all">
                {renderLinks(
                  isIncludeOriginalMessage || user?.isTranslationEnabled
                    ? c?.content || c?.translatedContent
                    : c?.translatedContent || c?.content,
                  "black"
                ) || ""}
              </span>
              {(isIncludeOriginalMessage || getTranslatedTextById()) && <br />}
              {isIncludeOriginalMessage &&
                c?.content !== c?.translatedContent &&
                !getTranslatedTextById() &&
                returnTranslatedContentGlobally(c?.translatedContent)}
              {returnTranslatedContent()}
            </div>
          )}
        </div>
      </MessageMetaInfo>
      {isMediaTrackingOpen && (
        <MediaTrackingDrawer
          open={isMediaTrackingOpen}
          onClose={() => setIsMediaTrackingOpen(false)}
          messageId={c?.id}
          leadId={selectedLead?.id}
        />
      )}
    </div>
  );
}

const EmailJSX = ({
  message,
  user,
  isMobileView,
  selectedLead,
  userName,
  originalUserName,
  isOttoEmail = false,
  hasAnyForwardOption,
  RenderPhone,
  // canViewTranslation,
  // visibleTranslateIcon,
  // RenderTranslation,
}) => {
  const replyEmailRef = useRef(null);
  const { isMobile, isTablet } = useDevice();
  const dispatch = useDispatch();
  const { user: currentUser } = useContext(UserContext);
  const { direction, email } = message;
  const [emailForm] = Form.useForm();
  const [isExpanded, setIsExpanded] = useState(false);
  const [isShowMore, setIsShowMore] = useState(false);

  const [replyEmail, setreplyEmail] = useState({
    visible: false,
    leadId: selectedLead?.id,
    leadOpportunityId: message?.leadOpportunity?.id,
    email: "",
    id: "",
    showSubject: false,
    mode: "Reply",
    emailData: null,
  });

  // Enhanced email details state to include the mode
  const [emailDetails, setEmailDetails] = useState({
    threadId: "",
    from: "",
    to: "",
    emailBody: "",
    mode: "", // Add mode to track whether it was Reply or Forward
  });

  // Function to parse the content
  /**
   *
   * @param {string} htmlBody
   * @returns
   */

  const {
    newMessage: initialContent,
    originalMessage: expandedContent,
    isReply,
  } = parseEmailReply(message?.content || "");

  const canSendEmail = checkAccessPermission(AccessPermissionAction.EMAIL_MANAGEMENT_SEND);

  const EmailDetails = () => {
    const emailDetailClassName = `flex flex-row items-start my-1`;
    const labelClassName = "text-xs font-normal text-[#64748B] w-12 text-right mr-2";
    const valueClassName = "text-xs font-normal text-[#334155] break-words";

    return (
      <div className={`flex flex-col w-full ${isOttoEmail ? "bg-grey-100 rounded-lg p-2" : ""}`}>
        <div className={emailDetailClassName}>
          <span className={labelClassName}>From:</span>
          <span className={valueClassName}>
            {["FROM_LEAD", "TO_USER"].includes(direction) ? selectedLead?.fullName : ""}{" "}
            {["FROM_LEAD", "TO_USER"].includes(direction) && selectedLead?.fullName ? <br /> : ""}
            {["FROM_LEAD", "TO_USER"].includes(direction)
              ? `<${email?.from_ || ""}>`
              : `${email?.from_ || ""}`}
          </span>
        </div>
        <div className={emailDetailClassName}>
          <span className={labelClassName}>To:</span>
          <span className={valueClassName}>
            {direction === "TO_LEAD" ? selectedLead?.fullName : ""}
            {direction === "TO_LEAD" && selectedLead?.fullName && <br />}
            {`${email?.to || ""}`}
          </span>
        </div>
        <div className={emailDetailClassName}>
          <span className={labelClassName}>Date:</span>
          <span className={valueClassName}>
            {convertUtcToLocal(
              message.dateSent || message.dateReceived,
              "ddd, DD MMM YYYY hh:mm A"
            )}
          </span>
        </div>
        <div className={emailDetailClassName}>
          <span className={labelClassName}>Subject:</span>
          <span className={valueClassName}>{email?.subject || ""}</span>
        </div>
      </div>
    );
  };

  const handleReplyEmail = () => {
    setreplyEmail({
      ...replyEmail,
      visible: true,
      leadId: selectedLead?.id,
      leadOpportunityId: message?.leadOpportunity?.id,
      showSubject: true,
      mode: "Reply",
      id: email?.id,
      email: message?.direction === "TO_LEAD" ? email.to : email.from_,
      emailData: {
        ...email,
        bodyHtml: message.content,
      },
    });
    // dispatch(setTextMode("Email"));
  };

  const handleForwardEmail = () => {
    setreplyEmail({
      ...replyEmail,
      visible: true,
      leadId: selectedLead?.id,
      leadOpportunityId: message?.leadOpportunity?.id,
      showSubject: true,
      mode: "Forward",
      email: "",
      emailData: {
        ...email,
        bodyHtml: message.content,
      },
    });
    // dispatch(setTextMode("Email"));
  };

  const [createEmail, { loading: emailLoader }] = useMutation(CREATE_EMAIL);
  const [mediaUploadLoader, setMediaUploadLoader] = useState(false);
  const [isSending, setIsSending] = useState(false);

  // A sent email can come back BOUNCE (recipient mailbox rejected it). Only
  // outbound (TO_LEAD) mail carries an actionable deliverability status — used
  // to gate the MessageMetaInfo retry footer that hosts <BouncedEmailResend>.
  const isBouncedSentEmail = direction === "TO_LEAD" && email?.status === EMAIL_STATUS_ENUMS.BOUNCE;

  const resetEmailDetails = () => {
    setEmailDetails({
      threadId: "",
      from: "",
      to: "",
      emailBody: "",
      mode: "",
    });
  };

  const isMessagePinned = !!message?.messageNotesCount;
  const [lang] = useLang();

  const emailBubbleContent = (
    <div
      className={`${
        direction === "TO_LEAD" ? "smaiChatSent ml-auto w-full" : "smaiChatRecieve"
      }  bg-white`}
    >
      {!isTypeOfCampaignEmail(message?.contentType) && (
        <div className="flex-row-centered items-center justify-between">
          <span className="text-md font-[500] text-grey-600 py-3 border-0 border-b border-solid border-grey-200 w-full">
            Subject: {message?.email?.subject || "No Subject"}
          </span>
        </div>
      )}

      <div>
        {isShowMore ? (
          <>
            <div
              className="thread-email-body"
              dangerouslySetInnerHTML={{
                __html: formatEmailBodyHtml(initialContent),
              }}
            />
            <span
              className="toggle-reply cursor-pointer font-semibold text-blue-500"
              onClick={() => setIsShowMore(false)}
            >
              See less
            </span>
          </>
        ) : (
          <>
            {(() => {
              const cleanContent = formatEmailBodyHtml(initialContent);
              const { content: truncatedContent, isTruncated } = ultraSmartTruncate(
                cleanContent,
                300
              );

              return (
                <>
                  <div
                    className="thread-email-body"
                    dangerouslySetInnerHTML={{
                      __html: truncatedContent,
                    }}
                  />
                  {isTruncated && (
                    <span
                      className="toggle-reply cursor-pointer font-semibold text-blue-500"
                      onClick={() => setIsShowMore(true)}
                    >
                      See more
                    </span>
                  )}
                </>
              );
            })()}
          </>
        )}
      </div>
      {/* <div dangerouslySetInnerHTML={{ __html: initialContent }} /> */}
      {isReply && (
        <div className="reply-section">
          <span
            className="toggle-reply text-[2rem] leading-[0] text-[#64748B] cursor-pointer"
            onClick={() => setIsExpanded(!isExpanded)}
          >
            {isExpanded ? "..." : "..."}
          </span>

          {isExpanded && (
            <blockquote
              className="border-0 border-l border-solid border-[#ccc] text-[#666] pl-2"
              dangerouslySetInnerHTML={{ __html: expandedContent }}
            />
          )}
        </div>
      )}
      {(message?.mmsObjects || []).length > 0 &&
        (message?.mmsObjects || []).map((item, index) => (
          <div
            key={index}
            className="rounded border border-solid flex-row-centered max-w-max gap-1 px-3 py-2 border-grey-200 bg-grey-50"
          >
            <span
              className="sm-400 text-brand-500 cursor-pointer"
              onClick={() => window.open(item.mediaUrl)}
            >
              {item?.mediaUrl?.split("/")?.pop()}
            </span>
            <span className="sm-400 text-grey-500">({formatBytes(item.size)})</span>
          </div>
        ))}
      <div className="flex-row-centered items-center justify-between">
        {["FROM_LEAD", "TO_USER", "TO_LEAD"].includes(message?.direction) && canSendEmail && (
          <div className="flex gap-2 items-center">
            <Tooltip title="Reply">
              <Button
                type="default"
                icon={<ReplyIcon />}
                onClick={() => handleReplyEmail()}
                className="flex items-center mt-2 text-xs text-grey-700 bg-white border border-grey-300 hover:bg-grey-50"
              >
                Reply
              </Button>
            </Tooltip>
            <Tooltip title="Forward">
              <Button
                type="default"
                icon={<ReplyIcon className="rotate-180 scale-y-[-1]" />}
                onClick={() => handleForwardEmail()}
                className="flex items-center mt-2 text-xs text-grey-700 bg-white border border-grey-300 hover:bg-grey-50"
              >
                Forward
              </Button>
            </Tooltip>
          </div>
        )}
      </div>
    </div>
  );

  // Resend action for a bounced outbound email. Rendered OUTSIDE the white
  // email bubble — passed into MessageMetaInfo's footer via showRetry /
  // RetryComponent, the same slot SMS/MMS use for their retry affordance.
  // Optimistically appends the resent message so it lands in the thread
  // immediately (mirrors the reply flow in ReplyEmail).
  const resendBouncedEmailButton = (
    <BouncedEmailResend
      direction={direction}
      status={email?.status}
      to={email?.to}
      subject={email?.subject}
      content={message?.content}
      leadId={selectedLead?.id || message?.leadId}
      leadOpportunityId={message?.leadOpportunityId}
      onResent={createdMessage => {
        if (createdMessage && selectedLead?.id) {
          dispatch(
            setSelectedLeadRedux({
              ...selectedLead,
              messages: [...(selectedLead.messages || []), createdMessage],
            })
          );
        }
      }}
    />
  );

  // For Otto emails, render without MessageMetaInfo (centered layout, no avatars)
  if (isOttoEmail) {
    return (
      <div className="max-w-full w-full mx-1">
        <div className="flex-col-centered w-full">
          <EmailDetails isOttoEmail={isOttoEmail} />
          {emailBubbleContent}
        </div>
      </div>
    );
  }

  // For regular emails, use MessageMetaInfo
  return (
    <div
      className={`msg-bubble-wrapper w-webkit-fill ${
        direction === "TO_LEAD" ? "flex justify-end" : "flex justify-start"
      }`}
    >
      <MessageMetaInfo
        direction={direction}
        leadOpportunityId={message?.leadOpportunityId}
        leadOpportunities={selectedLead?.leadOpportunities}
        messageType={message?.messageType}
        contentType={message?.contentType}
        avatarUser={{
          fullName: message?.user?.fullName || user?.fullName,
          profilePic: message?.user?.profilePic,
        }}
        leadName={message?.selectedLead?.fullName || selectedLead?.fullName || ""}
        timestamp={direction === "TO_LEAD" ? message?.dateSent : message?.dateReceived}
        timestampFormat="hh:mm A"
        userName={userName}
        RenderPhone={RenderPhone}
        phoneNumber={
          direction === "TO_LEAD" ? message?.email?.to || "" : message?.email?.from_ || ""
        }
        phoneDirection={direction}
        phoneLabel="Email"
        tooltipClassName="text-left"
        isMessagePinned={isMessagePinned}
        messageNotesCount={message?.messageNotesCount}
        messageId={message?.id}
        messageContent={message?.content}
        messageUser={message?.user}
        originalUserId={message?.originalUserId}
        originalUserName={originalUserName}
        messageUserId={message?.userId}
        hasAnyForwardOption={hasAnyForwardOption}
        isAutoResponder={userName === lang.autoResponderUserName}
        emailStatus={message?.email?.status}
        EmailDetailsPopover={<EmailDetails />}
        showRetry={isBouncedSentEmail}
        RetryComponent={resendBouncedEmailButton}
      >
        {emailBubbleContent}
      </MessageMetaInfo>

      {replyEmail.visible && (
        <Drawer
          open={replyEmail.visible}
          onClose={() => {
            // Save the current email details before closing the drawer
            const emailContent = replyEmailRef?.current?.getContent() || "";
            setEmailDetails({
              threadId: message?.email?.id,
              emailBody: emailContent,
              mode: replyEmail.mode, // Save the mode (Reply or Forward),
              subject: replyEmailRef?.current?.getSubject() || "",
            });
            setreplyEmail({ visible: false, email: "", mode: "Reply" });
          }}
          width={isMobile ? "100%" : isTablet ? "80%" : "40%"}
          destroyOnClose
          title={
            replyEmail?.mode === "Forward"
              ? "Forward Email"
              : `Reply to ${
                  direction === "TO_LEAD"
                    ? replyEmail?.email
                    : replyEmail?.emailData?.from_ || replyEmail?.email || ""
                }`
          }
          footer={
            <div className="flex-row-centered w-full items-center">
              <div className="flex-row-centered gap-1">
                <Button
                  loading={isSending || emailLoader || mediaUploadLoader}
                  onClick={() => emailForm.submit()}
                  type="primary"
                >
                  Send
                </Button>
                <Button
                  onClick={() => {
                    setreplyEmail({ visible: false, email: "" });
                    resetEmailDetails();
                  }}
                >
                  Cancel
                </Button>
              </div>
            </div>
          }
          afterOpenChange={open => {
            // Only restore content if it's the same thread ID AND the same mode
            if (
              open &&
              message?.email?.id === emailDetails.threadId &&
              replyEmail.mode === emailDetails.mode
            ) {
              setTimeout(() => {
                if (replyEmailRef?.current?.setContent) {
                  replyEmailRef.current.setContent(emailDetails.emailBody);
                }
                if (replyEmailRef?.current?.setSubject && emailDetails.subject) {
                  replyEmailRef.current.setSubject(emailDetails.subject);
                }
              }, 500); // Give the component time to mount fully
            }
          }}
        >
          <ReplyEmail
            key={message.id}
            // @ts-ignore
            showReply={replyEmail}
            // @ts-ignore
            setshowReply={setreplyEmail}
            selectedLead={selectedLead}
            emailForm={emailForm}
            createEmail={createEmail}
            selectedEmail={email}
            refetchEmails={() => {}}
            refetchEmailListFn={() => {}}
            textMode="Email"
            ref={replyEmailRef}
            resetEmailDetails={resetEmailDetails}
            mediaUploadLoader={mediaUploadLoader}
            setMediaUploadLoader={setMediaUploadLoader}
            onSubmitStateChange={setIsSending}
          />
        </Drawer>
      )}
    </div>
  );
};

function ReviewUI({ c, selectedLead }) {
  const { getOpprDetails } = useCrm();

  const leadOpportunity = c?.reviewResponse?.leadOpportunity;

  const { label: opportunityLabel, crmLink: opportunityHref } = leadOpportunity
    ? getOpprDetails({ opportunity: leadOpportunity, crmLeadObj: selectedLead?.crmLeadObj })
    : {};

  // Assigned-user row renders the single `user` nested under reviewResponse.
  const reviewUser = c?.reviewResponse?.user;
  const userName = reviewUser
    ? `${reviewUser.firstName || ""} ${reviewUser.lastName || ""}`.trim()
    : "";
  const userCompanyRole = reviewUser?.companyRole?.name || "";
  const assignedUsers = userName
    ? [userCompanyRole ? `${userName} (${userCompanyRole})` : userName]
    : [];

  // Prefer the vehicle flagged isPrimary; fall back to the first one when
  // none is marked primary.
  const vehicles = getUniqueVehicleOfInterest(leadOpportunity?.vehiclesOfInterest);
  const primaryVehicle = vehicles?.find(v => v.isPrimary) || vehicles?.[0];
  const vehicleLabel = getVehicleName(primaryVehicle);

  // Root opp-type (Sales/Service/...) badge — only computed here, for the
  // review message's drawer, not for every message in the thread.
  const rootOppTypeId = getRootOppTypeIdForLeadOpportunityId(
    c?.leadOpportunityId,
    selectedLead?.leadOpportunities
  );
  const rootOppTypeName = rootOppTypeId ? getRootConfig(rootOppTypeId).displayName : null;

  return (
    <ReviewTrackingInline
      data={c?.trackingDetails}
      negativeComment={c?.reviewResponse?.comment}
      reviewType={c?.reviewResponse?.responseType}
      timestamp={c?.reviewResponse?.commentTs}
      leadName={selectedLead?.fullName}
      opportunityLabel={opportunityLabel}
      opportunityHref={opportunityHref}
      assignedUsers={assignedUsers}
      vehicleLabel={vehicleLabel}
      rootOppTypeName={rootOppTypeName}
    />
  );
}

function MergedLeadUI({ c }) {
  const dataSource = JSON.parse(c?.content)?.map((item, index) => ({
    key: `${index + 1}`,
    name: item.fullname,
    email: item.merge_history.email[0]?.email || "N/A",
    phone: item.merge_history.phone[0]?.phone || "N/A",
    leadSource: item.lead_source || "N/A",
    status: item?.status || "N/A",
    voi: `${item?.merge_history?.vehicle_of_interest[0]?.make || ""} ${
      item?.merge_history?.vehicle_of_interest[0]?.year || ""
    } ${item?.merge_history?.vehicle_of_interest[0]?.model || ""}`,
  }));

  const columns = [
    {
      dataIndex: "name",
      key: "name",
      onCell: () => ({
        style: {
          color: "#3B82F6",
          backgroundColor: "#DCFCE7",
        },
      }),
    },
    {
      dataIndex: "leadSource",
      key: "leadSource",
      onCell: () => ({
        style: { backgroundColor: "#DCFCE7" },
      }),
    },
    {
      dataIndex: "phone",
      key: "phone",
      onCell: () => ({
        style: { backgroundColor: "#DCFCE7" },
      }),
    },
    {
      dataIndex: "voi",
      key: "voi",
      render: value => <span>{value?.trim() || "No vehicle"}</span>,
      onCell: () => ({
        style: { backgroundColor: "#DCFCE7" },
      }),
    },
    {
      dataIndex: "status",
      key: "status",
      onCell: () => ({
        style: { backgroundColor: "#DCFCE7" },
      }),
    },
  ];

  return (
    <Table
      dataSource={dataSource}
      columns={columns}
      pagination={false}
      className="hide-header divider-table"
    />
  );
}

function MergedOpportunityUI({ c }) {
  const dataSource = JSON.parse(c?.content)?.map((item, index) => ({
    key: `${index + 1}`,
    role: item?.role,
    crm_integration: item.crm_integration || "N/A",
    status: item?.status || "N/A",
    voi:
      item?.merge_history?.vehicle_of_interest[0]?.make +
      item?.merge_history?.vehicle_of_interest[0]?.year +
      item?.merge_history?.vehicle_of_interest[0]?.model,
  }));

  const columns = [
    {
      dataIndex: "crm_integration",
      key: "crm_integration",
      onCell: () => ({
        style: {
          color: "#3B82F6",
          // backgroundColor: "#DCFCE7",
        },
      }),
    },
    {
      dataIndex: "voi",
      key: "voi",
      render: value => <span>{value || "No vehicle"}</span>,
      // onCell: () => ({
      //   style: { backgroundColor: "#DCFCE7" },
      // }),
    },
    {
      dataIndex: "role",
      key: "role",
      // onCell: () => ({
      //   style: { backgroundColor: "#DCFCE7" },
      // }),
    },
    {
      dataIndex: "status",
      key: "status",
      // onCell: () => ({
      //   style: { backgroundColor: "#DCFCE7" }, // Background for cells
      // }),
    },
  ];

  return (
    <Table
      dataSource={dataSource}
      columns={columns}
      pagination={false}
      className="hide-header divider-table"
    />
  );
}

function OttoMessage(props) {
  const {
    SetContentBy,
    c,
    user,
    userIdMap,
    selectedLead,
    toPhone,
    RenderRetry,
    messageCategory,
    isOpenOttoMessage,
    setisOpenOttoMessage,
    isReview,
    isLeadMerged,
    isOpportunityMerged,
    canEmailView,
    hasAnyForwardOption,
    RenderPhone,
  } = props;
  const isMobileView = useSelector(state => getMobileView(state));
  const dispatch = useDispatch();
  const messageFeedback = c?.messageFeedback || "";
  const [feedback, setFeedback] = useState(
    messageFeedback.includes("BAD") ? "bad" : messageFeedback.includes("GOOD") ? "good" : null
  );
  const [isFeedbackSent, setIsFeedbackSent] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isFeedbackListOpen, setIsFeedbackListOpen] = useState(false);
  const [form] = Form.useForm();

  // Whether this message has any feedback yet (decides list-vs-add on the feedback click).
  const hasExistingFeedback = !!(messageFeedback || c?.messageFeedbackNote);

  const handleFeedback = type => {
    if (hasExistingFeedback) {
      // Capture the clicked thumb so the edit/add form opens in that
      // Good/Negative mode, then surface the list of existing feedback.
      setFeedback(type);
      setIsFeedbackListOpen(true);
      return;
    }
    setFeedback(feedback === type ? null : type);
    setIsDrawerOpen(true);
  };

  const handleFeedbackSubmit = values => {
    setIsFeedbackSent(true);
    setIsDrawerOpen(false);
    form.resetFields();
    dispatch(
      setMessageFeedback({
        messageId: c?.id,
        feedback: values.feedback,
        feedbackNote: values.feedbackNote || "",
        feedbackOptionIds: values.feedbackOptionIds || [],
      })
    );
  };

  const handleDrawerClose = closeFlag => {
    setIsDrawerOpen(false);
    if (closeFlag) {
      setFeedback(null);
    }
    setIsFeedbackSent(false);
    form.resetFields();
  };
  const messageContentType = (c?.contentType || "").toLowerCase();
  const showOttoMessage =
    isReview && (c?.trackingDetails || []).length > 0
      ? [
          MESSAGE_CONTENT_TYPES.REVIEW_REQUEST_SENT.toLowerCase(),
          MESSAGE_CONTENT_TYPES.CAMPAIGN_MESSAGE_TO_LEAD.toLowerCase(),
          MESSAGE_CONTENT_TYPES.CAMPAIGN_REVIEW_REQUEST_SENT_TO_LEAD.toLowerCase(),
          MESSAGE_CONTENT_TYPES.MANUAL_REVIEW_REQUEST_SENT_TO_LEAD.toLowerCase(),
        ].includes(messageContentType)
      : true;

  const isMessageToLead =
    c?.direction === "TO_LEAD" ||
    ((c?.direction === "FROM_OTTO" || c?.direction === "FROM_LEAD") &&
      !c?.dateReceived &&
      !!c?.dateSent);

  const RecieverName =
    c?.direction === "TO_LEAD"
      ? selectedLead?.fullName || ""
      : c?.direction === "FROM_OTTO" || c?.direction === "FROM_LEAD"
      ? c?.dateReceived
        ? `${c.user?.firstName || ""} ${c.user?.lastName || ""}`.trim()
        : c?.dateSent
        ? selectedLead?.fullName || ""
        : ""
      : "";

  const isSending = c?.type === "queued" || c?.type === "new";

  // Opp-type badge — see useOpportunityBadge for the full explanation.
  // Unlike the SMS/Email paths, this centered banner covers system
  // messages (appointment reminders, status updates, review requests)
  // whose ``direction`` doesn't cleanly map to TO_LEAD/FROM_LEAD, so the
  // badge shows whenever the message resolves to a real opportunity,
  // regardless of direction.
  const opportunityBadge = useOpportunityBadge(
    c?.leadOpportunityId,
    selectedLead?.leadOpportunities
  );

  return showOttoMessage ? (
    <div
      className="w-[95%] h-full flex flex-col items-center justify-center mx-auto max-w-[800px]"
      style={
        isSending
          ? { opacity: 0.6, transition: "opacity 200ms ease-in-out" }
          : { transition: "opacity 200ms ease-in-out" }
      }
    >
      <div className="flex flex-col w-full items-center">
        <div className="relative w-full max-w-[600px] mx-auto py-2 px-4">
          {/* Centered BANNER */}
          <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-10 flex items-center gap-1.5">
            {opportunityBadge}
            <Tooltip
              title={
                isMessageToLead
                  ? c?.messageType === "EMAIL"
                    ? "Sent email to lead"
                    : "Sent to lead"
                  : c?.messageType === "EMAIL"
                  ? "Sent email to employee"
                  : "Sent to employee"
              }
            >
              <div
                style={{ backgroundColor: messageCategory.backgroundColor }}
                className={`p-[1px] inline-flex items-center rounded-full cursor-pointer ${
                  isMessageToLead ||
                  MESSAGE_CONTENT_TYPES.REVIEW_BAD_FROM_LEAD.toLowerCase().includes(
                    messageContentType
                  )
                    ? "cancel-otto"
                    : "normal-otto"
                }`}
                onClick={() => setisOpenOttoMessage(!isOpenOttoMessage)}
              >
                <div className="bg-white p-[5px] rounded-full flex items-center gap-2 whitespace-nowrap">
                  {messageCategory.icon}
                  <span className="text-xs font-semibold text-grey-700">
                    {messageCategory.title}
                  </span>
                  <CaretDownOutlined
                    className={`transition-all duration-500 ${
                      isOpenOttoMessage ? "rotate-180" : ""
                    }`}
                  />
                </div>
              </div>
            </Tooltip>
          </div>

          {/* FLEX WRAPPER for name and time, hugging center */}
          <div className="flex justify-between items-center w-full">
            {/* Name (right-aligned, flex-end) */}
            <div className="flex-1 text-right text-xs text-[#64748B] truncate pr-1 max-w-[45%]">
              <Tooltip title={`${toPhone && "To: "} ${toPhone}` || RecieverName}>
                <span>{RecieverName}</span>
              </Tooltip>
            </div>

            {/* Spacer for banner (same width as actual banner, incl. the
                opp badge when present) so the name/time rows never
                overlap the absolutely-positioned banner above them. */}
            <div className="opacity-0 pointer-events-none flex items-center gap-1.5 justify-center">
              {opportunityBadge}
              <div className="bg-white px-2 py-0.5 rounded-full flex items-center gap-2 whitespace-nowrap">
                {messageCategory.icon}
                <span className="text-xs font-semibold text-grey-700">{messageCategory.title}</span>
                <CaretDownOutlined />
              </div>
            </div>

            {/* Time (left-aligned, flex-start) */}
            <div className="flex-1 text-left text-xs text-[#64748B] truncate pl-1 max-w-[45%]">
              <Tooltip
                title={convertUtcToLocal(
                  c?.dateSent || c?.dateReceived,
                  "ddd, MMM Do YYYY, h:mm A"
                )}
              >
                <span>{convertUtcToLocal(c?.dateSent || c?.dateReceived, "h:mm A")}</span>
              </Tooltip>
            </div>
          </div>
        </div>

        {c?.messageType === "EMAIL" && (
          <div className="flex flex-row w-full items-center justify-center text-[#64748B] sm:text-nowrap text-xs font-[400] text-center mb-4">
            {renderEmailStatus(c?.email?.status)}
            {c?.email?.subject || ""}
          </div>
        )}
      </div>
      {isOpenOttoMessage && (
        <>
          <div
            style={{ wordBreak: "break-word" }}
            className={`w-full md:w-[75%] whitespace-pre-wrap p-[1px] rounded-lg flex flex-col justify-start ${
              isMessageToLead ||
              MESSAGE_CONTENT_TYPES.REVIEW_BAD_FROM_LEAD.toLowerCase().includes(messageContentType)
                ? "cancel-otto"
                : "normal-otto"
            }`}
          >
            <div className="flex flex-col justify-start items-start space-y-6 bg-white rounded-lg p-3.5 gap-1">
              {c?.messageType.toLowerCase() === "email" ? (
                <div className="text-grey-700 text-[14px] font-normal leading-6 w-full">
                  {canEmailView ? (
                    <EmailJSX
                      message={c}
                      user={c?.user}
                      isMobileView={isMobileView}
                      selectedLead={selectedLead}
                      canViewTranslation={false}
                      visibleTranslateIcon={false}
                      RenderTranslation={() => <></>}
                      isOttoEmail
                      hasAnyForwardOption={hasAnyForwardOption}
                      RenderPhone={RenderPhone}
                    />
                  ) : null}
                </div>
              ) : (
                <div className="text-grey-700 text-[14px] font-normal leading-6">
                  {(isLeadMerged && <MergedLeadUI c={c} />) ||
                    (isOpportunityMerged &&
                      (() => {
                        let parsedContent = [];
                        try {
                          parsedContent = c?.content ? JSON.parse(c.content) : [];
                        } catch (error) {
                          parsedContent = [];
                        }

                        return (
                          <div>
                            <div className="bg-[#DCFCE7] p-4 rounded-md mb-4">
                              {parsedContent.length} duplicate opportunities are merged with
                              Dealersocket {parsedContent[0]?.crm_integration || "N/A"}
                            </div>

                            <MergedOpportunityUI c={c} />
                          </div>
                        );
                      })()) ||
                    renderLinks(SetContentBy(c, userIdMap), "black") ||
                    ""}
                </div>
              )}
              {/* {c?.messageType !== "EMAIL" && (
                <span className="text-xs font-[400] text-left">
                  {isOpenOttoMessage && !isEmpty(toPhone) ? `To: ${toPhone}` : ``}
                </span>
              )} */}
            </div>
          </div>
          {(shouldShowAiFeedback({
            direction: c?.direction,
            contentType: c?.contentType,
            campaignType: c?.campaign?.campaignType?.type,
            dateSent: c?.dateSent,
          }) ||
            c?.type === "error" ||
            c?.messageStatus === "FAILED" ||
            c?.messageStatus === "UNDELIVERED") && (
            <div
              className={`w-full md:w-[75%] flex items-center gap-2 ${
                shouldShowAiFeedback({
                  direction: c?.direction,
                  contentType: c?.contentType,
                  campaignType: c?.campaign?.campaignType?.type,
                  dateSent: c?.dateSent,
                })
                  ? "justify-between"
                  : "justify-center"
              }`}
            >
              {shouldShowAiFeedback({
                direction: c?.direction,
                contentType: c?.contentType,
                campaignType: c?.campaign?.campaignType?.type,
                dateSent: c?.dateSent,
              }) && (
                <AiFeedbackButtons
                  feedback={feedback}
                  messageFeedback={messageFeedback}
                  isFeedbackSent={isFeedbackSent}
                  onFeedback={handleFeedback}
                />
              )}
              {(c?.type === "error" ||
                c?.messageStatus === "FAILED" ||
                c?.messageStatus === "UNDELIVERED") && (
                <span className="whitespace-nowrap">
                  <RenderRetry allowRetry={false} />
                </span>
              )}
            </div>
          )}
        </>
      )}
      {isReview && <ReviewUI {...props} />}
      {isSending && (
        <div className="flex items-center gap-1 text-[11px] italic text-black-45 mt-1">
          <span
            className="inline-block w-2 h-2 rounded-full"
            style={{
              backgroundColor: "#9CA3AF",
              animation: "smai-pulse 1.2s ease-in-out infinite",
            }}
          />
          <span>Sending…</span>
          <style>{`
            @keyframes smai-pulse {
              0%, 100% { opacity: 0.4; }
              50%      { opacity: 1; }
            }
          `}</style>
        </div>
      )}
      {isDrawerOpen && (
        <MessageFeedback
          isDrawerOpen={isDrawerOpen}
          onClose={handleDrawerClose}
          onFeedbackSubmit={handleFeedbackSubmit}
          form={form}
          messageId={c?.id}
          feedbackType={MESSAGE_FEEDBACK_TYPE.CAMPAIGN}
          user={user}
          feedback={feedback || messageFeedback?.toLowerCase() || ""}
          feedbackNote={c?.messageFeedbackNote || ""}
          messageContent={c?.content || ""}
          reasonForResponse={c?.reasonForResponse || ""}
          campaign={c?.campaign}
          lead={selectedLead}
          feedbackOptionIds={
            (c?.messageFeedbackOptionSelection || []).map(item =>
              typeof item === "object" ? item?.messageFeedbackOption?.id || item?.id : item
            ) || []
          }
        />
      )}
      {isFeedbackListOpen && (
        <MessageFeedbackList
          isDrawerOpen={isFeedbackListOpen}
          currentUserId={user?.id}
          messageId={c?.id}
          onClose={() => setIsFeedbackListOpen(false)}
          onAddNew={() => {
            setIsFeedbackListOpen(false);
            setIsDrawerOpen(true);
          }}
          onEdit={() => {
            // Open the edit form in the mode of the thumb the user clicked
            // (captured in handleFeedback) so they can keep or flip the rating.
            setIsFeedbackListOpen(false);
            setIsDrawerOpen(true);
          }}
        />
      )}
    </div>
  ) : null;
}
